import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListingPageComponent } from './listing-page/listing-page.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatCardModule } from '@angular/material/card';
import { ListingPageRoutingModule } from './listing-page-routing.module';
import { SharedModule } from '../@shared/shared.module';
import { ListingTitleComponent } from './listing-title/listing-title.component';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { ReqFiltersPageModule } from '../req-filters-page/req-filters-page.module';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ListingFilterPageModule } from '../listing-filter-page/listing-filter-page.module';
import { MatButtonModule } from '@angular/material/button';
import { SharedExceptMainModule } from '../@shared-except-main/shared-except-main.module';
import { FooterPageModule } from '../footer/footer-page.module';
import { ListingContainerComponent } from './listing-container.component';
import { SearchListingFilterPageModule } from '../search-listing-filter-page/search-listing-filter-page.module';
import { OfferToggleModule } from '../offer-toggle/offer-toggle.module';
import { FooterV2Module } from '../footer-v2/footer-v2.module';

@NgModule({
    declarations: [
        ListingPageComponent,
        ListingTitleComponent,
        ListingContainerComponent,
    ],
    imports: [
        CommonModule,
        FlexLayoutModule,
        MatCardModule,
        ListingPageRoutingModule,
        SharedModule,
        SharedExceptMainModule,
        MatIconModule,
        MatSelectModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        ReqFiltersPageModule,
        MatProgressSpinnerModule,
        ReqFiltersPageModule,
        ListingFilterPageModule,
        MatButtonModule,
        FooterPageModule,
        SearchListingFilterPageModule,
        OfferToggleModule,
        FooterV2Module,
    ],
    exports: [ListingPageComponent],
})
export class ListingPageModule {}
